import style from './SubmitBtn.module.css';
import { Button, ButtonProps } from '../Button/Button.tsx';

export function SubmitBtn(props: ButtonProps) {
  return <Button {...props} type="submit" className={style.btnSubmit} />;
}
